<ion-header>
  <ion-toolbar mode="ios">
    <ion-title
      text-medium
      class="ion-text-center"
      font-bold=""
      *ngIf="buttonClicked === 'VerifyInvoice'"
    >
      Verify Invoice
    </ion-title>
    <ion-title
      text-medium
      class="ion-text-center"
      font-bold=""
      *ngIf="buttonClicked === 'RejectInvoice'"
    >
      Reject Invoice
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="3">
        <ion-item input-item lines="none">
          <ion-label text-small class="ion-text-center">PickupId</ion-label>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item input-item lines="none">
          <ion-text text-regular="">{{ formattedId }}</ion-text>
        </ion-item>
      </ion-col>
      <ion-col size="12">
        <ion-item
          input-item=""
          centered=""
          style="width: 95% !important"
          lines="none"
        >
          <ion-textarea
            centered=""
            font-medium=""
            [(ngModel)]="comments"
            placeholder="Write your comment"
          ></ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer no-box-shadow="" centered="">
  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <ion-button
          recykal-button=""
          centered=""
          color="primary"
          expand="block"
          (click)="verifyInvoice()"
          >Verify Invoice
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button
          recykal-button=""
          centered=""
          color="danger"
          expand="block"
          (click)="rejectInvoice()"
          >Reject Invoice
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
